// extracted by mini-css-extract-plugin
export default {"appContainer":"FpWP7JCuWKc8EE5krmWq","mainContent":"BD3FSwLnUFN3vPpnuplC"};